// The sticky header, adapted from design/isomorphic/src/layouts/header.tsx (Isomorphic's
// hydrogen header and sticky-header): below xl a hamburger opens the rail as a drawer; the
// search field is a placeholder until search exists.
import { List, MagnifyingGlass } from "@phosphor-icons/react";
import { useState } from "react";
import { Link, useLocation } from "react-router";
import { ActionIcon, Drawer } from "rizzui";

import { useT } from "../i18n";
import { cn } from "../ui/cn";
import { LogoMark } from "../ui/Logo";
import { HeaderActions } from "./HeaderActions";
import { RailContent } from "./Rail";

function SearchPlaceholder() {
  const t = useT().shell.header;
  return (
    <div
      className="hidden h-10 w-full max-w-sm cursor-not-allowed items-center rounded-xl border border-muted bg-gray-0/60 px-3.5 text-gray-500 dark:bg-gray-50/60 md:flex"
      title={t.searchUnavailable}
      aria-hidden
    >
      <MagnifyingGlass weight="bold" className="me-2 h-4 w-4" />
      <span className="text-[13px]">{t.searchPlaceholder}</span>
      <kbd className="ms-auto rounded-md border border-muted bg-gray-100 px-1.5 py-0.5 font-mono text-[11px] text-gray-600">⌘K</kbd>
    </div>
  );
}

export function Header({ className }: { className?: string }) {
  const t = useT().shell;
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header className={cn("sticky top-0 z-[990] flex items-center gap-3 bg-page/80 px-4 py-3.5 backdrop-blur-xl md:px-5 lg:px-6 xl:py-4", className)}>
      <ActionIcon aria-label={t.header.openMenu} variant="text" className="me-1 h-9 w-9 shrink-0 rounded-lg text-gray-800 xl:hidden" onClick={() => setOpen(true)}>
        <List weight="bold" className="h-5 w-5" />
      </ActionIcon>
      <Link to="/" className="shrink-0 xl:hidden" aria-label={t.pages.home.title}>
        <LogoMark className="h-8 w-8" />
      </Link>
      <SearchPlaceholder />
      <HeaderActions />
      {/* Re-mounted per route so a navigation from inside the drawer closes it. */}
      <Drawer key={pathname} isOpen={open} onClose={() => setOpen(false)} placement="left" customSize={300} containerClassName="bg-rail">
        <div className="flex h-full flex-col overflow-y-auto">
          <RailContent onNavigate={() => setOpen(false)} />
        </div>
      </Drawer>
    </header>
  );
}
